import React from 'react'
import {Backdrop, CircularProgress, makeStyles, Theme } from '@material-ui/core';
import { BackDropState } from '../../reducers/components/BackDropReducer';
import { RootState } from '../../reducers/index';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme: Theme) => ({
    backDrop: {
        zIndex: theme.zIndex.drawer + 100000
    }
  }));
  
export default function BackDrop() {
    const classes = useStyles();
    const backDropData = useSelector<RootState, BackDropState>(
        (state) => state.backDropDetails
      );
    return (
        <div>
             <Backdrop
                className={classes.backDrop}
                            open={backDropData.open}
                        >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}
